import * as THREE from 'three';

export const glass = new THREE.MeshPhysicalMaterial({
  flatShading: true,
  transparent: true,
  transmission: 0.9,
  opacity: 1.0,
  roughness: 0.2,
  metalness: 0.3
});

export const cider = new THREE.MeshPhysicalMaterial({
  flatShading: true,
  color: "red",
  transmission: 0.1,
  opacity: 0.7,
  roughness: 0,
  metalness: 0
});

export const cap = new THREE.MeshStandardMaterial({
  flatShading: true,
  color: "#806f5c",
  metalness: 0.5,
  roughness: 0.5,
  side: THREE.DoubleSide
});


const labelDefaults = {
  flatShading: true,
  roughness: 0.3,
  metalness: 0.1
}

export const label = {
  back: new THREE.MeshStandardMaterial({ ...labelDefaults, side: THREE.DoubleSide }),

  front: {
    outer: new THREE.MeshStandardMaterial({ ...labelDefaults, transparent: false }),
    inner: new THREE.MeshStandardMaterial({ ...labelDefaults, side: THREE.BackSide })
  },

  top: {
    outer: new THREE.MeshStandardMaterial({ ...labelDefaults, transparent: false }),
    inner: new THREE.MeshStandardMaterial({ ...labelDefaults, side: THREE.BackSide })
  }
}